import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { Suspendable } from '@components';
import { ROUTES } from '@constants';

const PlayerOffers = Suspendable(
  lazy(() =>
    import('@modules/playerOffers/controller/PlayerOffersController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

const PlayerOffersDetails = Suspendable(
  lazy(() =>
    import('@modules/playerOffers/submodules/PlayerOfferDetails/controller/PlayerOfferDetailsController').then(
      (module) => ({
        default: module.default,
      })
    )
  )
);

export const PlayerOffersRoutes: RouteObject[] = [
  {
    element: <PlayerOffers />,
    path: ROUTES.PLAYER_OFFERS.ROOT,
  },
  {
    element: <PlayerOffersDetails />,
    path: ROUTES.PLAYER_OFFERS.DETAILS,
  },
];
